type Rules = {
  required?: true;
  requiredAndTrue?: true;
  requiredBoolean?: true;
  min?: number;
  max?: number;
  betweenValue?: [number, number];
  numeric?: true;
  email?: true;
  password?: true;
  confirmation?: string;
  not_same?: string;
  zen_kana?: true;
  zipcode_length?: true;
  ym?: true;
  pattern?: true;
  tel?: string;
  minValue?: number;
};
export const validationRuleHelper = (rules: Rules) => {
  return rules;
};
